module.exports = __webpack_public_path__ + "static/media/kizuna-full.0620a9f2.png";